/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdierrorcodeList.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edierrorcode-list";

export class AutogenModelEdierrorcodeList<RowType extends ModelRow> extends Endpoint<RowType, RowEdierrorcodeListFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdierrorcodeList extends ModelRow<RowEdierrorcodeListFields> {
	constructor(values?: Partial<RowEdierrorcodeListFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdierrorcodeListFields {
	code: string;
	company_id: string;
	description: string;
	id: number;
}

